import * as React from 'react';
import { Empty, Table } from "antd";
import { getRole } from "../../../Repository/ContractRepository";
import { getUserName } from '../../../Helper/DataHelper'
import { MultipleSelectTableProps } from "../MultipleChoicesWithTable";
import ActionButton from "./ActionButton";

export default function MultipleChoicesTableUsers(props: MultipleSelectTableProps) {
  const { dataSource, onRemove, onEdition } = props;

  if (!dataSource) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Name',
      key: 'name',
      render: (record: any) => {
        const style = { fontSize: '13px' };
        const roles = record.value.contractRoles;
        const rolesLabels = roles && roles.map((role: string) => {
          const currentRole = getRole(role)?.label;
          return currentRole;
        })
        return <div>
          <div>{getUserName(record.value)}</div>
          {roles &&
            <div style={{ padding: '10px 0 0 0' }}>
              <span style={{ ...style, fontWeight: 'bold' }}>Roles: </span>
              <span style={{ ...style, fontStyle: 'italic', marginLeft: '5px' }}>
                {rolesLabels.join(', ')}
              </span>
            </div>
          }
        </div>
      }
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (record: any) => {
        return <ActionButton
          record={record}
          onOk={onEdition}
          onRemove={() => onRemove && onRemove(record)}
        />
      }
    }
  ];

  return <Table
    dataSource={[...dataSource]}
    columns={columns}
  />
}